export const getCostPerType = (
    repairType: string,
    assetType: string | undefined
) => {
    return Math.round(100 + Math.random() * 100);
};
